"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDistractorsToString = void 0;
const mapDistractorsToString = (distractors) => {
    return distractors.map((d) => d.toString());
};
exports.mapDistractorsToString = mapDistractorsToString;
